/**
 * Which dashboard a viewer gets. An admin picks with the "Dashboard 2.0" switch in the profile
 * menu (off by default, so they start on the legacy one) whatever their permissions; anyone else
 * gets 2.0 only with `reporting.dashboard_v2`.
 */
export const showsDashboardV2 = ({
    isAdmin,
    adminUsesLegacy,
    hasV2Permission,
}: {
    isAdmin: boolean;
    adminUsesLegacy: boolean;
    hasV2Permission: boolean;
}): boolean => (isAdmin ? !adminUsesLegacy : hasV2Permission);
